import { IState } from '../../../../store/types';
import { connect } from 'react-redux';
import { CallLangMenu } from '../components/CallLangMenu';
import { ICallLangMenuFields } from '../components/types';
import { getAuthUserLangCode } from '../../../../store/general/selectors';
import { findLanguageByCode } from '../../../../store/models/selectors';
import { CallSelectors } from '../../../../store/call/selectors';
import { CallLangs } from '../../langs';

const mapStateToProps = () => {
	return (
		state: IState,
	): ICallLangMenuFields => {
		const langCode = getAuthUserLangCode(state);
		const lang = findLanguageByCode(state, langCode);
		let langTitle = lang?.name || '';

		const isUnsupported = !CallLangs.LANGS.find(i => i.code === langCode);

		return {
			langCode,
			langTitle,
			isUnsupported: false,
		}
	};
}

export const CallLangMenuHOC = connect(
	mapStateToProps,
	null
)(CallLangMenu);

CallLangMenuHOC.displayName = 'CallLangMenuHOC';
